import { render, staticRenderFns } from "./OpenPlatformDashboard.vue?vue&type=template&id=5f961b3e"
import script from "./OpenPlatformDashboard.vue?vue&type=script&lang=js"
export * from "./OpenPlatformDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports